const getFormDataPayload = (formData) => {
  //get personalise name label
  var nameInput = document.getElementById("personalisation-name");

  if (nameInput && !nameInput.checkValidity()) {
    nameInput.reportValidity();
    return;
  }

  const nameValue = nameInput
    ? document.querySelector("#personalisation-name").value
    : null;
  const variantId = document.querySelector("#personalisation-id");
  const forValue = nameInput
    ? document.querySelector("#personalisation-for").value
    : null;
  const isBundle = !forValue;
  const personaliseNameItem =
    nameValue && forValue
      ? {
          id: variantId.value,
          quantity: 1,
          properties: {
            Name: nameValue,
          },
        }
      : null;

  const payload = {
    items: [
      personaliseNameItem,
      isBundle && nameValue
        ? {
            ...Object.fromEntries(formData),
            properties: {
              Name: nameValue,
            },
          }
        : Object.fromEntries(formData),
    ],
  };

  return JSON.stringify(payload);
};

const addToCartWithJson = (data, subBtn) => {
  if (subBtn) {
    subBtn.classList.add("is-loading");
    subBtn.setAttribute("disabled", true);
  }

  fetch(theme.routes.cart_add_url, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: data,
  })
    .then((response) => response.json())
    .then((response) => {
      subBtn.disabled = false;
      subBtn.classList.remove("is-loading");

      if (response.status) {
        window.cart.addToCartError(response);
        window.cart.removeLoadingClass();
        window.cart.scrollToCartTop();
        return;
      }

      // window.cart.hideAddToCartErrorMessage();

      if (window.cart.cartDrawerEnabled) {
        window.cart.getCart();
      } else {
        window.location = theme.routes.cart_url;
      }
    })
    .catch((error) => console.log(error));
};

const initPersonalisation = () => {
  var nameInput = document.getElementById("personalisation-name");
  const addToCartBtn = document.querySelector(".product__submit__add");
  if (nameInput) {
    addToCartBtn.removeAttribute("data-add-to-cart");
    addToCartBtn.addEventListener("click", function (e) {
      e.preventDefault();
      const formData = new FormData(document.querySelector(".product__form"));
      const payload = getFormDataPayload(formData);
      console.log(payload);
      if (payload) {
        addToCartWithJson(payload, addToCartBtn);
      }
    });
  }
};

initPersonalisation();

const updateCartNote = () => {
  const cartNote = document.querySelector("#note");
  if (!cartNote) return;
  let note = "";
  window.cart.items.forEach((item) => {
    const title = item.dataset.itemTitle;
    const property = item.querySelector(
      ".cart__item__property span:last-child",
    );
    if (!property) return;
    const name = property.innerText;

    console.log(title, name);
    if (title.includes("Custom Side Labels") || title.includes("Kit")) {
      if (title.includes("Harness: XS") || title.includes("/ XS")) {
        note += "XS";
      } else if (title.includes("Harness: S") || title.includes("/ S")) {
        note += "S";
      } else {
        note += "ML";
      }
    }
    note += ` | ${name}\n`;
  });
  cartNote.value = note;
};
window.addEventListener("theme:cart:update", updateCartNote);
window.addEventListener("theme:cart:open", () => {
  document
    .querySelector("#cart-drawer button[type=submit]")
    .addEventListener("click", updateCartNote);
  document.querySelector("[data-item-remove]").addEventListener("click", () => {
    setTimeout(() => {
      updateCartNote();
    }, 1000);
  });
  setTimeout(() => {
    updateCartNote();
  }, 1000);
});

const productGalleryCache = new WeakMap();

const escapeHtml = (value = "") => {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/"/g, "&quot;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;");
};

const readJsonScript = (container, selector, errorMessage) => {
  const script = container?.querySelector(selector);

  if (!script) {
    return null;
  }

  try {
    return JSON.parse(script.textContent);
  } catch (error) {
    console.error(errorMessage, error);
    return null;
  }
};

const syncSelectedMediaState = (container, selectedMediaKey) => {
  container.querySelectorAll(".product-single__media-slide").forEach((slide) => {
    const isSelected = slide.getAttribute("data-media-id") === selectedMediaKey;

    slide.classList.toggle("is-selected", isSelected);
    slide.classList.toggle("media--hidden", !isSelected);
  });

  container.querySelectorAll(".product-single__thumbnail").forEach((thumb) => {
    const isSelected = thumb.getAttribute("data-thumbnail-id") === selectedMediaKey;

    thumb.classList.toggle("is-nav-selected", isSelected);
  });
};

const getActiveProductContext = (event) => {
  const container =
    event?.target?.closest?.("[data-product]") ||
    window.product?.container ||
    document.querySelector("[data-product]");
  const productApi = window.product?.container === container ? window.product : null;

  return { container, productApi };
};

const getCurrentVariant = (container, event) => {
  if (event?.detail?.variant) {
    return event.detail.variant;
  }

  const productForm = window.product?.productForm;
  if (
    window.product?.container === container &&
    typeof productForm?.getFormState === "function"
  ) {
    return productForm.getFormState().variant;
  }

  const productData = readJsonScript(
    container,
    "[data-product-json]",
    "Error parsing product JSON",
  );

  if (!productData?.variants?.length) {
    return null;
  }

  const variantId =
    container.querySelector("[data-product-select]")?.value ||
    new URLSearchParams(window.location.search).get("variant");

  return (
    productData.variants.find(
      (variant) => String(variant.id) === String(variantId),
    ) || productData.variants[0]
  );
};

const getVariantImages = (container, variantId) => {
  const variants = readJsonScript(
    container,
    "[data-variant-json]",
    "Error parsing variant JSON",
  );

  if (!Array.isArray(variants)) {
    return [];
  }

  const matchedVariant = variants.find(
    (variant) => String(variant.id) === String(variantId),
  );

  return matchedVariant?.metafields?.variant_images ?? [];
};

const getProductGalleryNodes = (container) => {
  const gallery = container?.querySelector("[data-product-single-media-group]");
  const slider = gallery?.querySelector("[data-product-single-media-slider]");

  if (!gallery || !slider) {
    return null;
  }

  if (!productGalleryCache.has(gallery)) {
    const thumbs = gallery.querySelector("[data-product-single-media-thumbs]");
    const firstImageHeight = slider.querySelector(
      ".product-single__media--image-height",
    );

    productGalleryCache.set(gallery, {
      gallery,
      slider,
      thumbs,
      fixedPaddingTop: firstImageHeight?.style.paddingTop || "",
      productTitle:
        container.querySelector("h1")?.textContent?.trim() || "Product image",
      sectionId: container.getAttribute("data-section-id") || "product",
      enableZoom: gallery.dataset.gallery === "true",
    });
  }

  return productGalleryCache.get(gallery);
};

const buildVariantMediaId = (sectionId, imageId) => {
  return `${sectionId}-variant-image-${imageId}`;
};

const getVariantImagePaddingTop = (image, galleryNodes) => {
  if (galleryNodes.fixedPaddingTop) {
    return galleryNodes.fixedPaddingTop;
  }

  const aspectRatio = Number(image?.aspect_ratio) || 1;
  return `${Math.round((100 / aspectRatio) * 10) / 10}%`;
};

const renderVariantSlide = (image, index, galleryNodes) => {
  const mediaId = buildVariantMediaId(galleryNodes.sectionId, image.image_id);
  const alt = escapeHtml(image.alt || galleryNodes.productTitle);
  const paddingTop = getVariantImagePaddingTop(image, galleryNodes);
  const imageHref = image.zoom_src || image.src;
  const zoomLink = galleryNodes.enableZoom
    ? `<a href="${imageHref}" class="product-single__media-link" rel="lightbox" data-zoom-wrapper><span class="visually-hidden">Open product image in lightbox</span></a>`
    : "";

  return `
    <div id="FeaturedMedia-${mediaId}"
      class="product-single__media-slide${index === 0 ? " is-selected" : " media--hidden"} flickity"
      data-product-slide
      data-id="${image.image_id}"
      data-image-id="${image.image_id}"
      data-aspectratio="${image.aspect_ratio || 1}"
      data-media-id="${mediaId}"
      data-type="image"
      data-product-single-media-wrapper>
      <div class="product-single__media product-single__media--image">
        <div class="product-single__media--image-height" style="padding-top: ${paddingTop};"></div>
        <figure class="lazy-image is-loading lazy-image--cover">
          <img
            src="${image.src}"
            alt="${alt}"
            class="is-loading img-object-cover"
            loading="${index === 0 ? "eager" : "lazy"}"
            ${index === 0 ? 'fetchpriority="high"' : ""}
            data-image-id="${image.image_id}">
        </figure>
        ${zoomLink}
      </div>
    </div>
  `;
};

const renderVariantThumbnail = (image, index, galleryNodes) => {
  const mediaId = buildVariantMediaId(galleryNodes.sectionId, image.image_id);
  const alt = escapeHtml(image.alt || galleryNodes.productTitle);
  const thumbSrc = image.thumb_src || image.src;
  const href = image.zoom_src || image.src;

  return `
    <div class="product-single__thumbnail flickity${index === 0 ? " is-nav-selected" : ""}"
      data-id="${image.image_id}"
      data-image-id="${image.image_id}"
      data-thumbnail-id="${mediaId}">
      <a href="${href}" class="product-single__thumbnail-link" aria-label="${escapeHtml(galleryNodes.productTitle)}">
        <figure class="lazy-image is-loading lazy-image--cover">
          <img src="${thumbSrc}" alt="${alt}" class="is-loading product-single__thumbnail-img img-object-cover" loading="lazy" data-image-id="${image.image_id}">
        </figure>
      </a>
    </div>
  `;
};

const renderVariantGallery = (container, productApi, variantImages) => {
  const galleryNodes = getProductGalleryNodes(container);

  if (!galleryNodes || !variantImages.length) {
    return;
  }

  if (typeof productApi?.destroyProductSlider === "function") {
    productApi.destroyProductSlider();
  }

  galleryNodes.slider.innerHTML = variantImages
    .map((image, index) => renderVariantSlide(image, index, galleryNodes))
    .join("");
  galleryNodes.slider.classList.toggle(
    "product-single__media-slider--single",
    variantImages.length === 1,
  );

  if (galleryNodes.thumbs) {
    if (variantImages.length > 1) {
      galleryNodes.thumbs.innerHTML = variantImages
        .map((image, index) => renderVariantThumbnail(image, index, galleryNodes))
        .join("");
      galleryNodes.thumbs.hidden = false;
      galleryNodes.thumbs.style.display = "";
    } else {
      galleryNodes.thumbs.innerHTML = "";
      galleryNodes.thumbs.hidden = true;
      galleryNodes.thumbs.style.display = "none";
    }
  }

  const selectedMediaKey = buildVariantMediaId(
    galleryNodes.sectionId,
    variantImages[0].image_id,
  );

  syncSelectedMediaState(container, selectedMediaKey);

  if (typeof productApi?.initMediaSwitch === "function") {
    productApi.initMediaSwitch();
  }

  if (typeof productApi?.checkSlider === "function") {
    productApi.checkSlider();
  } else if (typeof productApi?.initProductSlider === "function") {
    productApi.initProductSlider();
  }

  if (productApi?.flkty) {
    productApi.flkty.selectCell(0, false, true);
  }

  if (productApi?.flktyNav) {
    productApi.flktyNav.selectCell(0, false, true);
  }
};

const updateVariantGallery = (event) => {
  const { container, productApi } = getActiveProductContext(event);

  if (!container) {
    return;
  }

  const variant = getCurrentVariant(container, event);
  if (!variant) {
    return;
  }

  const variantImages = getVariantImages(container, variant.id);
  if (!variantImages.length) {
    return;
  }

  renderVariantGallery(container, productApi, variantImages);
};

window.addEventListener("theme:variant:change", updateVariantGallery);

const initVariantGallery = () => {
  let attempts = 0;

  const tryInitGallery = () => {
    attempts += 1;

    const hasProductContainer = Boolean(
      window.product?.container || document.querySelector("[data-product]"),
    );

    if (!hasProductContainer && attempts <= 10) {
      return;
    }

    clearInterval(interval);
    updateVariantGallery();
  };

  const interval = setInterval(tryInitGallery, 100);
  tryInitGallery();
};

window.addEventListener("load", initVariantGallery);
